
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ChatMessage } from '../../lib/chat/ChatMessage'

import BacModal from '../BacModal.vue'
import BacButton from '../BacButton.vue'
import { ChatService } from '@/lib/chat/ChatService'
import { Game } from '@/lib/models/Game'

@Component({
  components: {
    BacModal,
    BacButton
  }
})
export default class ChatMessageChangeChallengeModal extends Vue {
  @Prop({ required: false }) chatService: ChatService | null = null;
  @Prop({ required: true }) chatMessageId!: number;

  games: Game[] = [];
  selectedGameId = 0

  mounted () {
    this.loadGames()
  }

  @Watch('$store.state.PageURLRallyRound.rallyRound')
  async loadGames () {
    if (!this.$store.state.PageURLRallyRound.rallyRound.id) {
      return // rally round not loaded yet
    }
    this.games = await Game.getForRallyRound(
      this.$store.state.PageURLRallyRound.rallyRound.id
    )
  }

  async changeChallenge () {
    const res = await ChatMessage.changeChallenge(
      this.chatMessageId,
      this.selectedGameId
    )

    if (this.chatService) {
      this.chatService.getLastMessages()
    }
  }
}
